<div class="participants">
  <header class="participants__header">
    <div class="participants__tabs">
      <span class="participants__title participants__title--participants">
        <stusan-icon icon="menu-participants"
                     class="participants__icon"
                     style="width: 24px; height: 24px;"
        ></stusan-icon>
        Participants
      </span>
    </div>
    <button class="participants__close"
            type="button"
            (click)="closeMenu()"
    >
      <stusan-icon icon="close"
                   class="participants__icon participants__icon--close"
                   style="width: 30px; height: 30px; fill: rgba(0,0,0,.14);"
      ></stusan-icon>
    </button>
  </header>
  <section class="participants__body">
    <ng-container>
      <thevatra-participant *ngFor="let source of videos; index as i; trackBy: trackByMethod"
                            [source]="source"
      ></thevatra-participant>
    </ng-container>
  </section>
</div>
